export const CANCEL_REGISTRATION = 'CANCEL_REGISTRATION';

export const CLEAR_EASY_JOIN_ERROR = 'CLEAR_EASY_JOIN_ERROR';

export const CLEAR_GOOGLE_ERROR = 'CLEAR_GOOGLE_ERROR';

export const CLEAR_RESELLER_TOKEN_ERROR = 'CLEAR_RESELLER_TOKEN_ERROR';

export const FETCH_REGISTRATION_TOKEN_START = 'FETCH_REGISTRATION_TOKEN_START';
export const FETCH_REGISTRATION_TOKEN_FULFILLED = 'FETCH_REGISTRATION_TOKEN_FULFILLED';
export const FETCH_REGISTRATION_TOKEN_REJECTED = 'FETCH_REGISTRATION_TOKEN_REJECTED';

export const FETCH_RESELLER_TOKEN_START = 'FETCH_RESELLER_TOKEN_START';
export const FETCH_RESELLER_TOKEN_FULFILLED = 'FETCH_RESELLER_TOKEN_FULFILLED';
export const FETCH_RESELLER_TOKEN_REJECTED = 'FETCH_RESELLER_TOKEN_REJECTED';

export const REGISTER_USER_START = 'REGISTER_USER_START';
export const REGISTER_USER_FULFILLED = 'REGISTER_USER_FULFILLED';
export const REGISTER_USER_REJECTED = 'REGISTER_USER_REJECTED';

export const RESET_EASY_JOIN = 'RESET_EASY_JOIN';

export const SET_GOOGLE_USER = 'SET_GOOGLE_USER';

export const SET_REGISTERING_WITH_GOOGLE = 'SET_REGISTERING_WITH_GOOGLE';
export const SET_REGISTERING_WITH_SSO = 'SET_REGISTERING_WITH_SSO';

export const SET_SUBMITTING = 'SET_SUBMITTING';

export const SUBMIT_EASY_JOIN_CODE_START = 'SUBMIT_EASY_JOIN_CODE_START';
export const SUBMIT_EASY_JOIN_CODE_FULFILLED = 'SUBMIT_EASY_JOIN_CODE_FULFILLED';
export const SUBMIT_EASY_JOIN_CODE_REJECTED = 'SUBMIT_EASY_JOIN_CODE_REJECTED';
